export default __webpack_public_path__ + "static/media/652.5f73c7bd.png";